//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import React from 'react';

import ControlWorkDates from './_control-work/assignment__date-tab_control-work';
import Empty from './_empty/assignment__date-tab_empty';
import LessonDates from './_lesson/assignment__date-tab_lesson';

interface Props {
    disabled: boolean;
    lessonMode: CLESSON_MODES | null;
    activeSubscriptionSlug: string | null;
}

export const AssignmentDateTab = React.memo((props: Props) => {
    const { lessonMode, disabled, activeSubscriptionSlug } = props;

    if (lessonMode === null) {
        return <Empty />;
    }

    if (lessonMode === CLESSON_MODES.CONTROL_WORK) {
        return <ControlWorkDates activeSubscriptionSlug={activeSubscriptionSlug} disabled={disabled} />;
    }

    return <LessonDates activeSubscriptionSlug={activeSubscriptionSlug} disabled={disabled} />;
});
